import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ModalService } from '@app/core/services/modal.service';
import { SrCheckListEquipmentGet, SrCheckListEquipmentItem, SrChecklistService } from '@app/services/sr-checklist.service';
import { SrRefundService } from '@app/services/sr-refund.service';

@Component({
    selector: 'tt-sr-check-list-equipment',
    templateUrl: './sr-check-list-equipment.component.html',
    styleUrls: ['./sr-check-list-equipment.component.css'],
    standalone: false,
})
export class SrCheckListEquipmentComponent implements OnInit {
    public page?: SrCheckListEquipmentGet;
    public equipments: SrCheckListEquipmentItem[] = [];
    public inputs: Item[] = [];
    public saving = false;
    public deleting = false;
    public calculating = false;

    constructor(
        private readonly checklist: SrChecklistService,
        private readonly refund: SrRefundService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.page = await this.checklist.getEquipment({
            checklistdata_keyno: String(this.navigator?.params['checklistdata_keyno'] ?? ''),
            srrefundtype_id: String(this.navigator?.params['srrefundtype_id'] ?? ''),
            srrefundinput_keyno: String(this.navigator?.params['srrefundinput_keyno'] ?? '0'),
        });
        const { checklistdata_keyno, srrefundtype_id, srrefundinput_keyno, resource_id } = this.page;
        const [equipments, inputs] = await Promise.all([
            [checklistdata_keyno, srrefundtype_id, srrefundinput_keyno, resource_id].every(value => !!value?.trim())
                ? this.checklist.getEquipmentChoices({ checklistdata_keyno, srrefundtype_id, srrefundinput_keyno, resource_id }) : Promise.resolve([]),
            srrefundinput_keyno?.trim() ? this.refund.getInputs({ srrefundinput_keyno }) : Promise.resolve([]),
        ]);
        this.equipments = equipments;
        this.inputs = inputs;
    }

    public async calculate(field: 'hours_total' | 'nbr_of_days' | 'equipment_km' | 'roadtoll_amount' | 'hours_postwork'): Promise<void> {
        if (!this.page || this.calculating) return;
        this.calculating = true;
        try {
            const value: unknown = await this.modal.showCalculator(field, undefined, this.page[field]);
            if (typeof value === 'string' || typeof value === 'number') this.page[field] = value;
        } finally { this.calculating = false; }
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving || this.deleting) return;
        this.saving = true;
        try {
            const response = await this.checklist.saveEquipment(this.page);
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.saving = false; }
    }

    public async deleteValues(): Promise<void> {
        if (!this.page || this.deleting || this.saving) return;
        this.deleting = true;
        try {
            const response = await this.checklist.deleteEquipment(this.page);
            if (response.errorcode !== '0') await this.showWarning(response.errormessage);
            else await this.navigator?.back();
        } finally { this.deleting = false; }
    }

    private showWarning(message: string): Promise<void> {
        return this.modal.show({ type: 'warning', title: 'Varsel', message, buttons: [{ label: 'OK', cssClass: 'btn-warning', close: true }] });
    }
}
